module.exports = __webpack_public_path__ + "img/teeth.c10e0faf.svg";